import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import clsx from "clsx";
import defaultStyles from "./Loading.module.scss";

export const Loading = ({
  className,
  label,
}: {
  className?: string;
  /** Announces the spinner as a `role="status"` region with this text. Omit for a decorative spinner. */
  label?: string;
}) => {
  const styles = useUiStyles(CoreUiComponents.Loading, defaultStyles);
  const [block] = useModuleBEM(styles, CoreUiComponents.Loading);
  return (
    <div className={clsx(block, className)} role={label ? "status" : undefined}>
      {label ? <span className="sr-only">{label}</span> : null}
    </div>
  );
};
